import { createStyles, makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Close from "@material-ui/icons/Close";
import React from "react";
import Draggable from "react-draggable";

const useStyles = makeStyles(() =>
  createStyles({
    overflowYVisible: { overflowY: "visible" },
    titleWrapper: {
      display: "flex",
      alignItems: "start",
    },
    title: {
      flex: 1,
      paddingRight: 0,
      cursor: "move",
    },
    closeButton: {
      margin: "0.5rem",
    },
  })
);

function PaperComponent(props: any) {
  const cssClasses = useStyles({});

  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} className={`${props.className} ${cssClasses.overflowYVisible}`} />
    </Draggable>
  );
}

interface ICustomDraggableDialogProps {
  title: React.ReactNode;
  content: React.ReactNode;
  isOpen: boolean;
  cancelText: React.ReactNode;
  acceptText: React.ReactNode;
  onCancel?: () => void;
  onAccept?: () => void;
  hideActions?: boolean;
  onClose?: () => void;
  acceptDisabled?: boolean;
}

const CustomDraggableDialog: React.FC<ICustomDraggableDialogProps> = (props) => {
  const cssClasses = useStyles({});

  const { onClose, hideActions, title, content, isOpen, cancelText, acceptText, onCancel, onAccept, acceptDisabled } =
    props;

  return (
    <div id={`dialog-main-div-${new Date().getTime()}`}>
      <Dialog
        open={isOpen}
        onClose={onCancel || onClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        className={cssClasses.overflowYVisible}
      >
        <div className={cssClasses.titleWrapper}>
          <DialogTitle className={cssClasses.title} id="draggable-dialog-title">
            {title}
          </DialogTitle>
          {onClose ? (
            <IconButton className={cssClasses.closeButton} aria-label="close" onClick={onClose}>
              <Close />
            </IconButton>
          ) : null}
        </div>
        <DialogContent className={cssClasses.overflowYVisible}>{content}</DialogContent>
        {!hideActions && (
          <DialogActions>
            <Button onClick={onCancel} color="primary">
              {cancelText}
            </Button>
            <Button onClick={onAccept} color="primary" disabled={acceptDisabled}>
              {acceptText}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

CustomDraggableDialog.defaultProps = {
  onCancel: () => {},
  onAccept: () => {},
} as Partial<ICustomDraggableDialogProps>;

export default CustomDraggableDialog;
